import { Injectable, signal } from '@angular/core';

/**
 * Which chat thread is actually on screen. Used to swallow OS pushes for that
 * conversation while the user is looking at it — the message already arrives
 * over SignalR. Backgrounded apps are unaffected: this is only consulted from
 * the foreground `pushNotificationReceived` callback.
 */
@Injectable({ providedIn: 'root' })
export class ChatViewingService {
  private readonly conversationId = signal<number | null>(null);

  setActiveConversation(id: number | null): void {
    this.conversationId.set(id != null && id > 0 ? id : null);
  }

  isViewing(conversationId: number): boolean {
    return conversationId > 0 && this.conversationId() === conversationId;
  }
}
